import type { ReactNode } from 'react';
import { Column } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';

/** Each topic owns its heading, help and controls; the parent owns spacing between topics. */
export function NotificationSection({
  title,
  description,
  children,
  separated = false,
}: {
  title: ReactNode;
  description: string;
  children: ReactNode;
  separated?: boolean;
}) {
  return (
    <Column
      gap="spacing.general.x3"
      borderTopWidth={separated ? 1 : 0}
      borderColor="border.secondary"
      paddingTop={separated ? 'spacing.general.x6' : undefined}
    >
      <Column gap="spacing.general.x2">
        {title}
        <Text variant="bodyBase">{description}</Text>
      </Column>
      {children}
    </Column>
  );
}
